import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { getPartners } from '../../../../../api/ApiEndpoints';
import { useTranslation } from 'react-i18next';
import './CompleteOrderForm.css';
import { useAlert } from 'react-alert';
import { loadOrder } from '../OrdersService';
import { DEFAULT_DATE_TIME } from '../../../../../components/common/Constants';
import { BDSMForm } from '../../../../../components/form/BDSMForm';
import * as Yup from 'yup';
import { CompleteOrderFormTable } from './CompleteOrderFormTable';
import { toDateString } from '../../../../../utils/TimeUtils';

export const CompleteOrderForm = ({ isShowing, onSubmit, onCancel, orderId }) => {

    const { t } = useTranslation();
    const alert = useAlert();
    const [partners, setPartners] = useState([]);
    const [order, setOrder] = useState(null);

    const validation = Yup.object().shape({
        invoice: Yup.string().required(t('validations:required')),
        invoiceDate: Yup.string()
            .transform(value => (value === null ? '' : value))
            .required(t('validations:required')),
    });

    useEffect(() => {
        if (isShowing && orderId != null) {
            loadOrder(orderId)
                .then((response) => {
                    let products = response.data.products.map(it => {
                        return { ...it, price: null, expiredDate: null };
                    });
                    setOrder({ ...response.data, products: products });
                })
                .catch(() => alert.error(t('alert:loadingError')));
            if (partners.length === 0) {
                getPartners()
                    .then((response) => setPartners(
                        response.data.map(it => ({ name: it.partnerName, value: it.id })),
                    ))
                    .catch(() => alert.error(t('alert:loadingError')));
            }
        }
    }, [isShowing, orderId]);

    const onClose = () => {
        setOrder(null);
        onCancel();
    };

    const submitOrder = (warehouseForm) => {
        if (isValidProducts()) {
            let products = order.products.map(product => {
                if (product.expiredDate != null) {
                    return { ...product, expiredDate: toDateString(product.expiredDate, DEFAULT_DATE_TIME) };
                }
                return product;
            });
            let request = {
                orderId: order.id,
                partnerId: order.partnerId,
                invoice: warehouseForm.invoice,
                invoiceDate: toDateString(warehouseForm.invoiceDate, DEFAULT_DATE_TIME),
                products: products,
            };
            setTimeout(() => {
                onClose();
            }, 500);
            onSubmit(request);
        }
    };

    const isValidProducts = () => {
        let result = true;
        order.products.forEach((product, index) => {
            let amountElement = document.getElementById('amount-' + index);
            if (product.amount != null && product.amount > 0) {
                amountElement.className = 'form-control';
            } else {
                result = false;
                amountElement.className = 'form-control is-invalid';
            }
            let priceElement = document.getElementById('price-' + index);
            if (product.price != null && product.price > 0) {
                priceElement.className = 'form-control';
            } else {
                result = false;
                priceElement.className = 'form-control is-invalid';
            }
        });
        return result;
    };

    const removeOrderProduct = (index) => {
        setOrder({ ...order, products: order.products.filter((product, idx) => idx !== index) });
    };

    const getFormModel = () => {
        let datePicker = {
            dateFormat: DEFAULT_DATE_TIME,
            showTime: true,
            timeFormat: 'HH:mm',
            timeIntervals: '15',
        };
        return {
            initValues: { invoice: '', invoiceDate: '' },
            onSubmit: (record) => submitOrder(record),
            onCancel: () => onClose(),
            validationSchema: validation,
            fieldNames: ['invoice', 'invoiceDate'],
            types: ['text', 'datePicker'],
            className: 'mb-3',
            label: [
                t('warehouse:invoice'),
                t('warehouse:invoiceDate'),
            ],
            selectData: [null, datePicker],
            inputFieldsClass: '',
        };
    };

    return (
        <>
            <Modal show={isShowing} onHide={onClose} backdrop="static" className={'modified-modal'}>
                <Modal.Header closeButton>
                    <div>
                        <Modal.Title>{t('order:complete.title')}</Modal.Title>
                        <Modal.Title>{order != null ? partners.find(it => it.value === order.partnerId).name : ''}</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {order != null
                            ? <CompleteOrderFormTable products={order.products}
                                                      onRemove={removeOrderProduct}></CompleteOrderFormTable>
                            : <></>}
                        <BDSMForm form={getFormModel()} />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};